import TutorialStep2_2 from './TutorialStep2_2';

export default TutorialStep2_2;
